<template>
    <div id="investment-plans-page">
        <LandingBanner />
        <Simulator />
        <PlansDetail />
        <!-- <CommitmentProgram /> -->
        <FAQs />
    </div>
</template>
    
<script>
import sal from 'sal.js';
import LandingBanner from '../../components/landing-components/investment-plans-components/LandingBanner.vue';
import PlansDetail from '../../components/landing-components/investment-plans-components/PlansDetail.vue';
import Simulator from '../../components/landing-components/investment-plans-components/Simulator.vue';
import CommitmentProgram from '../../components/landing-components/investment-plans-components/CommitmentProgram.vue';
import FAQs from '../../components/landing-components/investment-plans-components/FAQs.vue';
export default {
    name: "InvestmentPlansPage",
    components: {
    LandingBanner,
    PlansDetail,
    Simulator,
    CommitmentProgram,
    FAQs
},
    mounted() {
        sal();
    },
    data() {
        return {

        }
    }
}
</script>
    
<style scoped>

</style>